<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>Installment component configuration</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center" class="p-0 m-0">
        <v-col cols="12" sm="3" md="3" class="p-0 m-0">
          <v-autocomplete rounded outlined dense v-model="ay" :items="aylist" item-text="ay" item-value="id"
            label="Academic year" placeholder="Enter Academic year" persistent-hint return-object
            single-line></v-autocomplete>
        </v-col>
        <v-col v-if="ay" cols="12" sm="3" md="3" class="pt-1">
          <v-btn class="button" @click="
              getInstallment();
              getMatrix();
              display = true;
            ">Proceed</v-btn>
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" max-width="900px">
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>Add new installment component configuration</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-col cols="12" sm="12" md="12">
            <v-card class="box">
              <v-row justify="center" dense class="p-0 m-0" v-if="edit_id == null">
                <v-col v-if="fees_installmentlist != ''" cols="12" sm="3" md="3" class="p-0 m-0">
                  <v-autocomplete rounded outlined dense v-model="fees_inst" :items="fees_installmentlist"
                    item-text="name" item-value="id" placeholder="Enter Fees Installemnt" label="Fees Installemnt"
                    persistent-hint single-line></v-autocomplete>
                </v-col>
                <v-col v-if="fees_inst" cols="12" sm="3" md="3" class="p-0 m-0">
                  <v-autocomplete multiple rounded outlined dense v-model="fees_component" :items="fees_component_list"
                    item-text="name" item-value="id" placeholder="Enter Fees Installemnt" label="Fees Component"
                    persistent-hint single-line></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
            <v-row justify="center">
              <v-btn class="button" @click="dialog = false">Cancel</v-btn>
              <v-btn class="button" v-if="fees_component" @click="save">Add</v-btn>
            </v-row>
          </v-col>
        </v-card>
      </v-dialog>
      <v-row dense justify="center" class="p-0 m-0" v-if="edit_id != null">
        <v-col v-if="fees_installmentlist != ''" cols="12" sm="3" md="3" class="p-0 m-0">
          <v-autocomplete rounded outlined return-object dense v-model="editedItem.feesinstallmentacademicyear"
            :items="fees_installmentlist" item-text="name" placeholder="Enter Fees Installemnt" label="Fees Installemnt"
            persistent-hint single-line></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3" md="3" class="p-0 m-0">
          <v-text-field rounded outlined dense readonly filled v-model="editedItem.feescomponentacademicyear"
            placeholder="Enter Fees Installemnt" label="Fees Component" persistent-hint single-line></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3" class="p-0 m-0">
          <v-btn class="button" @click="update()">Update</v-btn>
        </v-col>
      </v-row>
      <v-toolbar v-if="display == true" flat dense>
        <v-spacer></v-spacer>
        <v-btn class="button" rounded @click="add">Add New Config</v-btn>
      </v-toolbar>
      <v-data-table v-if="fees_config.length > 0" :headers="headers" :items="fees_config" dense
        class="elevation-1 mytable" :search="search">
        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {

  components: {
    Breadcrumbs,
  },

  data: () => ({
    errorMsg: {},

    // extraBreadcrumbItems: [
    //   { text: "Installment component configuration", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    search: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    load: false,
    dialog: false,
    headers: [
      { text: "Sr. No.", value: "srno" },
      { text: "Academic Year", value: "academicyear" },
      { text: "Installment", value: "feesinstallmentacademicyear" },
      { text: "Fees Component", value: "feescomponentacademicyear" },
      { text: "Actions", value: "action", sortable: false },
    ],
    aylist: "",
    ay: null,
    fees_installmentlist: "",
    fees_inst: null,
    fees_component_list: "",
    fees_component: null,
    fees_config: "",
    edit_id: null,
    editedItem: [],
    display: false,
  }),
  mounted() {
    this.onload();
  },

  methods: {
    add() {
      this.dialog = true;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.edit_id = item.id;
    },
    update() {
      if (this.editedItem.feesinstallmentacademicyear.id) {
        this.editedItem.feesinstallmentacademicyear_id =
          this.editedItem.feesinstallmentacademicyear.id;
      } else {
        this.editedItem.feesinstallmentacademicyear_id =
          this.editedItem.feesinstallmentacademicyear_id;
      }
      const data = {
        editvalue: this.editedItem,
      };
      axios
        .post("/AccountingAndFees/editfeesInstallmentConfiguration", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar(
              "#4caf50",
              " Fess Installment Configuration updated Successfully..."
            ); // show snackbar on success
            this.getMatrix();
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
        })
        .finally(() => {
          // //close loader
          this.edit_id = null;
        });
    },
    getMatrix() {
      const data = {
        ay: this.ay.id,
      };
      axios
        .post("/AccountingAndFees/feesInstallmentConfiguration", data)
        .then((res) => {
          this.fees_config = res.data.fees_config;
          this.fees_component_list = res.data.fees_component_list;
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
        });
    },
    getInstallment() {
      const data = {
        ay: this.ay.id,
      };
      axios
        .post("/AccountingAndFees/feesComponent", data)
        .then((res) => {
          this.fees_installmentlist = res.data.fees_installment_list;
          this.fees_component_list = res.data.fees_component_list;
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
        });
    },
    save() {
      const data = {
        ay: this.ay.id,
        fees_inst: this.fees_inst,
        fees_component: this.fees_component,
      };
      axios
        .post("/AccountingAndFees/savefeesInstallmentConfiguration", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar(
              "#4caf50",
              " Fess Installment Configuration added Successfully..."
            ); // show snackbar on success
            this.getMatrix();
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
        })
        .finally(() => {
          // //close loader
          this.fees_inst = null;
          this.fees_component = null;
          this.dialog = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/AccountingAndFees/installmentConfig")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.aylist = res.data.aylist;
            this.ay = res.data.academicYear;
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
